// extracted by mini-css-extract-plugin
export default {"container":"SPTextArea_container__Ug07H","focus":"SPTextArea_focus__nw1RW","input":"SPTextArea_input__DbasE"};